import { createKeyRequest, createScheduleRequest } from '@/api/printers/hotb'
import { createSubmissionRequest } from '@/api/printers/project'
import * as tenderBidHelper from '@/api/printers/tenderBid'
import store from '@/store'
import HTTP from '@/utils/http'
import i18n from '@/utils/i18n'
import { hotbPremiseBuildingType } from '@/utils/locale'
import userHelper from '@/utils/userHelper'
import { save } from '@/utils/xfs'
import { getRegionalWorkPermitLabel } from '@/modules/workPermits/regionalWorkPermitLabels'

async function exportPDF (request) {
  const response = await HTTP.post('/pdf', request, { responseType: 'arraybuffer' })
  const fileBlobURL = save(response)
  if (userHelper.isIOSMobile()) {
    window.open(fileBlobURL)
  }
  return null
}

export async function exportTenderSummary (request = {}) {
  request.filename = `PR${request.prNumber}–Tender Summary.pdf`
  request.pdfType = 'tenderSummary'
  const user = store.getters['user/currentUser'] || {}
  request.username = userHelper.getUserName(user.username, user.displayName)
  const persistedPdfId = await exportPDF(request)
  return persistedPdfId
}

export async function exportTenderBid (tender = {}, bidService) {
  const request = await tenderBidHelper.buildRequest(tender, bidService)
  request.filename = `Tender Bid ${request.general.prNumber}.pdf`
  request.pdfType = 'tenderBid'
  const persistedPdfId = await exportPDF(request)
  return persistedPdfId
}

export async function exportQuery (tender = {}) {
  const request = await tenderBidHelper.buildQueryRequest(tender)
  request.filename = `Tender Query ${request.prNumber}.pdf`
  request.pdfType = 'tenderQuery'
  const persistedPdfId = await exportPDF(request)
  return persistedPdfId
}

export async function exportSubmission (project = {}, lastOrder) {
  const request = await createSubmissionRequest(project, lastOrder)
  request.filename = `Project Submissions ${request.poNumber}.pdf`
  request.pdfType = 'projectSubmission'
  const persistedPdfId = await exportPDF(request)
  return persistedPdfId
}

export async function exportHotbSchedule (hotb = {}, remarksListRequest = [], imgUrls = {}, regionName) {
  const request = createScheduleRequest(hotb, remarksListRequest, regionName)
  const projectType = request.isHandover ? i18n.t('tenancyProject.handover') : i18n.t('tenancyProject.takeback')
  request.filename = `${i18n.t('pdf.filename.schedule', [ projectType, request.tenant ])}.pdf`

  request.pdfType = 'hotbSchedule'
  request.options = {
    header: {
      height: '28mm',
    },
  }
  if (!request.isHandover && request.remarksListAsIsRadio === 'UNEDITABLE' && request.premiseBuildingType === hotbPremiseBuildingType.asIs) {
    request.addPointsTag = true
  }
  Object.assign(request, imgUrls)
  const persistedPdfId = await exportPDF(request)
  return persistedPdfId
}

export async function exportKeyHotb (hotb = {}, imgUrls = {}, regionName) {
  const request = createKeyRequest(hotb, regionName)
  const projectType = request.isHandover ? i18n.t('tenancyProject.handover') : i18n.t('tenancyProject.takeback')
  request.filename = `${i18n.t('pdf.filename.key', [ projectType, request.tenant ])}.pdf`

  request.pdfType = 'keyHotb'
  Object.assign(request, imgUrls)
  const persistedPdfId = await exportPDF(request)
  return persistedPdfId
}

export async function exportProjectPermit (request) {
  request.pdfType = 'workPermit'
  request.filename = `${i18n.t('pdf.filename.workPermit')}.pdf`
  request.options = {
    footerHeight: '14mm',
  }
  if (request.code) {
    request.filename = `${i18n.t('pdf.filename.workPermit')}-${request.code}.pdf`
  }
  const persistedPdfId = await exportPDF(request)
  return persistedPdfId
}

export async function exportHoisting (hoistingInfo = {}) {
  hoistingInfo.pdfType = 'hoisting'
  hoistingInfo.filename = `${getRegionalWorkPermitLabel('hoisting')}-${hoistingInfo.code}.pdf`
  const persistedPdfId = await exportPDF(hoistingInfo)
  return persistedPdfId
}

export async function exportSAPermit (request = {}) {
  request.pdfType = 'workPermitSA'
  request.filename = `${i18n.t('pdf.filename.workPermit')}.pdf`
  request.options = {
    footerHeight: '14mm',
  }
  if (request.code) {
    request.filename = `${i18n.t('pdf.filename.workPermit')}-${request.code}.pdf`
  }
  const persistedPdfId = await exportPDF(request)
  return persistedPdfId
}

export async function exportT3Permit (request = {}) {
  request.pdfType = 'workPermitT3'
  request.filename = `${i18n.t('pdf.filename.workPermit')}.pdf`
  request.options = {
    footerHeight: '14mm',
  }
  if (request.code) {
    request.filename = `${i18n.t('pdf.filename.workPermit')}-${request.code}.pdf`
  }
  const persistedPdfId = await exportPDF(request)
  return persistedPdfId
}

export async function exportBlankTenderBid (tender = {}) {
  const request = await tenderBidHelper.buildBlankPdfRequest(tender)
  request.filename = `Tender Bid ${request.general.prNumber}.pdf`
  request.pdfType = 'tenderBid'
  const persistedPdfId = await exportPDF(request)
  return persistedPdfId
}
